import type { FC, ReactNode } from 'react';

import { L10nText } from '../../../../services/uiTranslations/reactBindings/L10nText';
import { BetLimitData, Limits } from '../../types';

import styles from './BetLimitsTable.module.css';

export interface BetLimitsTableProps {
  betLimitData: BetLimitData[];
  renderLimit: (limit: Limits) => ReactNode;
}

export const BetLimitsTable: FC<BetLimitsTableProps> = ({ betLimitData, renderLimit }) => {
  return (
    <table>
      <thead>
        <tr>
          <th>
            <L10nText tk="BETLIMITS" />
          </th>
          <th>
            <L10nText tk="PAYOUT" />
          </th>
        </tr>
      </thead>

      <tbody>
        {betLimitData.map((betLimits) => {
          // bets grouped within certain category (group)
          if ('bets' in betLimits) {
            const { bets, limits, name } = betLimits;
            return (
              <>
                <tr>
                  <td>
                    <strong>{name}</strong>
                    <span className={styles.limit}>{renderLimit(limits)}</span>
                  </td>
                </tr>
                {bets?.map((bet, index) => (
                  <tr key={`${bet.name}-${index}`} className={styles.betGroup}>
                    <td>{bet.name}</td>
                    <td>{bet.payout}</td>
                  </tr>
                ))}
              </>
            );
          } else {
            const { name, limits, payout } = betLimits;

            return (
              <tr key={name.toString()}>
                <td>
                  <strong>{name}</strong>
                  <span className={styles.limit}>{renderLimit(limits)}</span>
                </td>
                <td>{payout}</td>
              </tr>
            );
          }
        })}
      </tbody>
    </table>
  );
};
